// extracted by mini-css-extract-plugin
export default {"root":"h42cg","toggle":"S_y_M","active":"gHhrl","dot":"Oxhlj"};